export const MessageStatus = Object.freeze({
    sending: "Sending",
    sent: "Sent",
    seen: "Seen",
    failedToSend: "Failed to send"
});